import { SimplyFade } from 'simply-fades';
document.addEventListener('DOMContentLoaded', () => {
    /**
     * Loads simply fades
     *
     * @docs https://www.npmjs.com/package/simply-fades
     */
    new SimplyFade();
});
